/* istanbul ignore file */

export const filterMessageOptions = [
  'One step closer to the perfect flight.',
  "Smart! You've narrowed your choices.",
  'Personalizing your flight results...',
]
